<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-primary">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3  text-white">よくある質問
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">依頼について</h2>
            <p class="lead">個人・法人、有償・無償問わず、様々な制作・寄稿・参加等の依頼について、雛菊書房及び小鳥遊 昴は以下のポリシーにて
              運用しております。</p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon name="fa fa-users" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">合同誌/アンソロジー等寄稿</h4>
            <p class="mt-3">合同誌/アンソロジー企画、及びその他同人誌へのゲスト原稿などの寄稿依頼については、積極的にお受けしております。
            但し、直近のイベントの開催頻度や、雛菊書房で現在進行中の企画、及び本人の多忙状況などにより、参加出来ない場合もございます。
            まずはTwitterで、ラフにお声掛けいただければと思います。よろしくお願いします。</p>
            <base-button tag="a" href="https://twitter.com/HinagikuBooks" type="info" class="mt-4" icon="fa fa-twitter">
              Twitter
            </base-button>

          </div>
          <div class="col-lg-4">
            <icon name="ni ni-money-coins" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">個人からの依頼</h4>
            <p class="mt-3">前述の合同誌・アンソロジー・ゲスト原稿以外に関する、雛菊書房及び小鳥遊 昴に対する個人からの依頼については、
            有償・無償問わず、お気軽に一度ご相談ください。ご連絡は、TwitterのDMからご連絡いただきたく、よろしくお願いします。</p>
            <p class="mt-3">また、短編の執筆依頼についてはSkebでもお受けしております。こちらは上記の依頼よりハードルの低い物としてご用意
            しております。状況によってはお受けできない場合もございますが、是非一度お気軽にご依頼ください。</p>
            <base-button tag="a" href="https://skeb.jp/@156million" type="primary" class="mt-4" icon="fa fa-pencil-square-o">
              Skeb依頼
            </base-button>
          </div>
          <div class="col-lg-4">
            <icon name="ni ni-building" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">法人・団体などからの依頼</h4>
            <p class="mt-3">法人、団体、組織など、個人以外からの雛菊書房及び小鳥遊 昴への依頼については、問い合わせページをご確認下さい。
              なお、その際は法人・団体・組織名、ご連絡ご担当者様のお名前、ご依頼の詳細などを明記していただきたく、よろしくお願いします。</p>
            <p class="mt-3">法人・団体・組織は、法人格を持つ組織の他、NPO/NGO等の法的に組織又は団体とされるもの、任意団体、など、実体としては個人で
            活動していても組織・団体を称していること、及び依頼及び依頼の成果物を組織・団体の名義で発行・販売する場合は該当します。但し、個人で運営・活動する
              同人サークルについてはこれに該当しません（個人扱いとなります）。</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg bg-secondary">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">よくある質問</h2>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon name="fa fa-pencil-square-o" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">Skebについて</h4>
            <p class="mt-3">Skebとは短文で手軽に有償でリクエストできるサービスです。「有償お題箱」などと言われることもあります。 雛菊書房では
            Skebでの短編の依頼を受け付けております。なお、Skebでの依頼については、Skebの規約により、依頼に関してSkeb以外での一切のやりとりを禁止
            されております。その他、細かな規約がございますので、必ずSkebの利用規約をご確認いただき、規約の範囲内でご依頼ください。</p>
            <p class="mt-3">なお、イベントの開催状況や現在のタスク、その他諸事情により、必ずしもお受けできることを保証できかねます。よろしくお願いします。</p>
            <base-button tag="a" href="https://skeb.jp/@156million" type="primary" class="mt-4" icon="fa fa-pencil-square-o">
              Skeb依頼
            </base-button>
          </div>
          <div class="col-lg-4">
            <icon name="ni ni-money-coins" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">キャッシュレス決済異議申立</h4>
            <p class="mt-3">弊サークルでは2021年11月より、即売会会場での支払い方法にキャッシュレス決済（クレジットカード、iD、QUICPay、
            交通系ICカード、各社QRコード決済など）を導入しております。各種支払い明細には、店舗名として「雛菊書房」と記載されます。</p>
            <p class="mt-3">もし、弊サークルで行った決済に起因する申立事項（購入金額との差異がある、購入していないのに決済されているなど）が
            ありましたら、大変お手数をおかけ致しますが、問合せページをご確認下さい。</p>
          </div>
          <div class="col-lg-4">
            <icon name="ni ni-send" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">感想、要望など</h4>
            <p class="mt-3">弊サークルの発行物に関する感想は大歓迎です。メール、Twitterでの空リプ/直リプ/DM、お手紙など、受け付けておりますので、
              遠慮なく送っていただければ、大変嬉しく思います。なお、特にTwitterについては、お返事が出来かねることもありますが、全て読んでおります。</p>
            <p class="mt-3">なお、次の同人誌の要望（カプやシチュエーションなど）は大変申し訳ございませんが受けかねます。代表が趣味と降りてきた
            ネタとその時の気分で筆を振り回しているため、ご期待に添えない可能性の方が高いためです。ご容赦ください。</p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon name="fa fa-pencil-square-o" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">通販(BOOTH)について</h4>
            <p class="mt-3">雛菊書房ではBOOTHにて各種書籍の通販を取り扱っております。</p>
            <p class="mt-3">通販に関するお問い合わせ、特に商品購入後のお問い合わせについては、必ずBOOTHのメッセージ機能からお問い合わせ下さい。
              BOOTHでは原則、匿名配送サービスを利用しているため、別の手段（Twitter、メールなど）でご連絡を頂いた場合、当該注文との紐付けが出来かねる場合がございます。</p>
          </div>
          <div class="col-lg-4">
            <icon name="ni ni-money-coins" size="lg" gradient="white" shadow round color="primary"></icon>
            <h4 class="mt-3">乱丁・落丁について</h4>
            <p class="mt-3">ご購入頂いた書籍の乱丁・落丁は、まず雛菊書房公式TwitterへDM等でご連絡ください。</p>
            <p class="mt-3">読むのに支障が出るレベルの乱丁・落丁の場合は、速やかに郵送等にて交換・返金等を承ります。それ以外の乱丁・落丁については、通販の場合はBOOTH事務局経由で返品・再送のお手続きを、現地購入の場合は次回イベント時に交換対応とさせていただきます。</p>
            <p class="mt-3">なお、既に完売した商品の乱丁・落丁については、大変恐れ入りますが、交換が難しい事、ご容赦ください。</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - FAQ' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」のよくある質問' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    }
  },
};
</script>
<style>
</style>
